// extracted by mini-css-extract-plugin
export default {"formField":"Opa-z","error":"Ppa-z","disabled":"Qpa-z","fieldError":"Rpa-z","errorText":"Spa-z","button":"Tpa-z","acknowledgment":"Upa-z"};